import { Entity } from "@hds/entity-lib";

class WebhookRegistrationEntity extends Entity {
    static DEFAULT_DOCUMENT = {};
    constructor(entityPersistence, seedData = {}, options = {}) {
        super(entityPersistence, seedData, options);
        this._virtualDataModel.fromJSON({
            ...WebhookRegistrationEntity.DEFAULT_DOCUMENT,
            ...seedData
        });
    }
    /*****************************************************/
    // START ENTITY DATA MODEL
    /*****************************************************/
    get eventName() {
        return this._virtualDataModel.getProperty('eventName');
    }
    set eventName(newEventName) {
        return this._virtualDataModel.setProperty('eventName', newEventName);
    }
    get registrationType() {
        return this._virtualDataModel.getProperty('registrationType');
    }
    set registrationType(newRegistrationType) {
        return this._virtualDataModel.setProperty('registrationType', newRegistrationType);
    }
    get registrationTypeConfig() {
        return this._virtualDataModel.getProperty('registrationTypeConfig');
    }
    set registrationTypeConfig(newRegistrationTypeConfig) {
        return this._virtualDataModel.setProperty('registrationTypeConfig', newRegistrationTypeConfig);
    }
}

//META PROPERTIES
Object.defineProperty(WebhookRegistrationEntity.prototype, '_meta', {
    value: {
        storeName: 'event-runtime',
        entityName: 'webhook-registration'
    }
}, { enumerable: false, configurable: false, writable: false, value: "static" });

export { WebhookRegistrationEntity };
export default WebhookRegistrationEntity;